import { type ButtonProps, IconButton } from '../../../buttons';
import { XIcon } from '../../../icons/phosphor';

export interface DialogCloseButtonProps extends Omit<ButtonProps, 'variant' | 'color'> {
    closeInvertedColor?: boolean;
}

export const DialogCloseButton = ({ closeInvertedColor, ...props }: DialogCloseButtonProps) => (
    <IconButton
        data-cy="dialog-dismiss-icon"
        sx={({ spacing, colors }) => ({
            padding: spacing(1),
            color: closeInvertedColor ? colors.text.inverse : 'text.secondary',
        })}
        {...props}
    >
        <XIcon size={24} />
    </IconButton>
);
